import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'hybse-admin-affiliatereport',
  templateUrl: './affiliatereport.component.html',
  styleUrls: ['./affiliatereport.component.css']
})
export class AffiliatereportComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/app/components/pages/affiliate/affiliatereport/affiliatereport.component.ts